module.exports = __webpack_public_path__ + "static/media/link.a52a2aae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/link.svg
// module id = 1412
// module chunks = 1